import { Edit, NoMeals } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ISupportCase, ISupportee, PermissionKeys, Table, useHasPermission, Widget } from '../../../shared';
import { UpdateFoodRestrictionsModal } from '../update-food-restrictions-modal/update-food-restrictions-modal.component';
import { GridCellParams, GridColDef } from '@mui/x-data-grid';
import { FullName } from '../full-name/full-name.component';
import { useSupportCaseFoodRestrictionsMapper } from '../../mappers';
import { IInfoSupportee } from '../../../registration/models';

interface Props {
    supportCase: ISupportCase;
}

export const FoodRestrictions: FC<Props> = ({ supportCase }) => {
    const { t } = useTranslation();
    const { hasPermission } = useHasPermission();
    const hasFoodRestrictionPermissions = hasPermission(PermissionKeys.SUPPORT_CASES_WRITE);

    const [foodRestrictionModal, setFoodRestrictionModal] = useState(false);
    const mappedRestrictions = useSupportCaseFoodRestrictionsMapper(supportCase);

    const columns: GridColDef[] = [
        {
            field: 'supportee',
            headerName: t('supportee'),
            minWidth: 100,
            flex: 1,
            sortable: false,
            renderCell: ({ row: { supportee } }: GridCellParams<{ supportee?: ISupportee | IInfoSupportee }>) =>
                supportee ? <FullName data={supportee} /> : <>{t('all')}</>,
        },
        { field: 'foodRestriction', headerName: t('foodRestriction'), minWidth: 100, flex: 1, sortable: false },
    ];

    return (
        <Widget
            icon={<NoMeals color="primary" />}
            title={t('foodRestrictions')}
            actions={
                hasFoodRestrictionPermissions && (
                    <IconButton onClick={() => setFoodRestrictionModal(true)}>
                        <Edit />
                    </IconButton>
                )
            }
            hasTable
        >
            {mappedRestrictions?.length === 0 ? (
                <Box p={2}> {t('emptyStateFoodRestrictions')}</Box>
            ) : (
                <Table
                    rows={mappedRestrictions || []}
                    columns={columns}
                    hideFooter
                    paginationMode="client"
                    columnHeaderHeight={40}
                    rowHeight={45}
                />
            )}

            <UpdateFoodRestrictionsModal
                open={foodRestrictionModal}
                supportCase={supportCase}
                handleClose={() => setFoodRestrictionModal(false)}
            />
        </Widget>
    );
};
